import s from './style.css';
import cn from 'classnames';

const LineWrapper = ({
	children,
	isEnd,
	plain,
	tight,
	className,
	snugPadding,
	topTight,
	trim
}) => (
	<div
		className={cn(s.wrap, {
			[s.isEnd]: isEnd,
			[s.plain]: plain,
			[s.tight]: tight,
			[s.trim]: trim,
			[s.topTight]: topTight,
			[s.snugPadding]: snugPadding,
			[className]: className
		})}
	>
		{children}
	</div>
);

export default LineWrapper;



// WEBPACK FOOTER //
// ./components/LineWrapper/index.js